/**
 * Opt-in runtime diagnostics for the "metallic material missing" investigation.
 *
 * Enabled only when the URL contains `?debugMaterials=1` (or `?debugMaterials`),
 * so it can be turned on against the live/deployed viewer without polluting the
 * console for normal users. All logging routes through `materialDebugLog`, which
 * is a no-op unless the flag is present.
 *
 * Remove this module (and its call sites) once the root cause is found.
 */

const FLAG = 'debugMaterials';

let cached: boolean | null = null;

/** True when `?debugMaterials` / `?debugMaterials=1` is present in the URL. */
export function isMaterialDebugEnabled(): boolean {
  if (cached !== null) return cached;
  if (typeof window === 'undefined' || !window.location?.search) {
    cached = false;
    return cached;
  }
  try {
    const params = new URLSearchParams(window.location.search);
    const value = params.get(FLAG);
    cached = params.has(FLAG) && value !== '0' && value !== 'false';
  } catch {
    cached = false;
  }
  return cached;
}

/** console.info gated behind the debug flag. */
export function materialDebugLog(label: string, payload?: unknown): void {
  if (!isMaterialDebugEnabled()) return;
  if (payload === undefined) {
    console.info(`[material-debug] ${label}`);
  } else {
    console.info(`[material-debug] ${label}`, payload);
  }
}
